import { createContext, useContext, useEffect, useMemo } from 'react'
import type { ECharts } from 'echarts'
import type { ChartTimeRange } from '@/lib/screenerHistory'

export interface ChartTimeNavigation {
  range: ChartTimeRange
  domain: ChartTimeRange
  navigate: (range: ChartTimeRange) => void
}
export const ChartTimeContext = createContext<ChartTimeNavigation | null>(null)

export function useChartTimeNavigation(chart: ECharts | null) {
  const navigation = useContext(ChartTimeContext)
  useEffect(() => {
    if (!chart || !navigation) return
    const zoom = () => {
      if (chart.isDisposed()) return
      const windows = chart.getOption().dataZoom as Array<{ id?: string; startValue?: number; endValue?: number }>
      const window = windows.find(item => item.id === 'screener-time')
      if (window?.startValue != null && window.endValue != null) {
        const next = { from: Number(window.startValue) / 1000, to: Number(window.endValue) / 1000 }
        if (Math.abs(next.from - navigation.range.from) > 0.01 || Math.abs(next.to - navigation.range.to) > 0.01) navigation.navigate(next)
      }
    }
    chart.on('datazoom', zoom)
    return () => { if (!chart.isDisposed()) chart.off('datazoom', zoom) }
  }, [chart, navigation])
  return useMemo(() => navigation ? {
    axis: { min: navigation.domain.from * 1000, max: navigation.domain.to * 1000 },
    zoom: { startValue: navigation.range.from * 1000, endValue: navigation.range.to * 1000,
      rangeMode: ['value', 'value'] as ['value', 'value'], minValueSpan: 1000 },
  } : { axis: {}, zoom: {} }, [navigation])
}
